import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { CUISINE_TYPE_NODE_FRAGMENT } from '../fragments'

const DELETE_CUISINE_TYPE_MUTATION = gql`
  mutation deleteCuisineType($id: ID!) {
    deleteCuisineType(id: $id) {
      results {
        ...CuisineTypeNodeFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${CUISINE_TYPE_NODE_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default DELETE_CUISINE_TYPE_MUTATION
